import React from "react";
import { Card } from "../components";
import weather1 from "../assets/weather1.PNG";
import { nostimo1, gamertech1, eCommerce2 } from "../assets";

function Projects() {
  return (
    <div
      id="Projects_link"
      className="h-full flex justify-start items-center flex-col scroll-mt-20 my-12"
    >
      <a href="#Projects_link" className="text-lavander text-6xl my-4">
        Projects
      </a>
      <hr className="w-1/2 h-3 text-white my-8 " />
      <div className="flex flex-wrap justify-center text-center">
        <div className="w-full flex flex-col items-center p-4 md:w-1/2">
          <h2 className="text-xl mb-4 font-medium md:text-4xl">Weather app ☁</h2>
          <a
            href="https://weather-free-app.vercel.app/"
            className="w-full ease-in-out duration-300 hover:brightness-125"
          >
            <Card
              name="Weather App"
              description={
                "Una sencilla app que muestra el clima de tu ciudad."
              }
              image={weather1}
            />
          </a>
          <p className="w-full my-3 text-md text-justify md:text-xl">
            Puedes buscar el clima actual de tu ciudad y
            conocer a detalle la temperatura actual, maxima, minima, el tipo de
            clima y detalles como velocidad del viento, humedad y presion.
            <br />
            Tecnologias: ReactJs, CSS
          </p>
        </div>
        <div className="w-full flex flex-col items-center p-4 md:w-1/2">
          <h2 className="text-xl mb-4 font-medium md:text-4xl">SPA Food Recipes 🍲</h2>
          <a
            href="https://front-food-five.vercel.app/"
            className="w-full ease-in-out duration-300 hover:brightness-125"
          >
            <Card
              name="Weather App"
              description={
                "Una sencilla app que muestra el clima de tu ciudad."
              }
              image={nostimo1}
            />
          </a>
          <p className="w-full my-3 text-md text-justify md:text-xl">
           Muestra tarjetas de distintas comidas, contiene un paginado para navegar entre las distinas recetas, puedes filtrar por tipo de dieta(ej. vegetarian, low food map, etc.), por orden alfabetico, puntuacion de salud y creacion de receta.   
            <br />
            Tecnologias: ReactJs, CSS Modules, Redux, Express, Sequelize, PostgreSQL 
          </p>
        </div>
        <div className="w-full flex flex-col items-center p-4 md:w-1/2">
          <h2 className="text-xl mb-4 font-medium md:text-4xl">E-Commerce (Hardware para pc) 💻</h2>
          <a
            href="https://e-commerce-sage-two.vercel.app/"
            className="w-full ease-in-out duration-300 hover:brightness-125"
          >
            <Card
              name="Weather App"
              description={
                ""
              }
              image={gamertech1}
            />
          </a>
          <p className="w-full my-3 text-md text-justify md:text:xl ">
            Contiene: Venta de perifericos y hardware, posibilidad de armar tu propia pc, seccion de favoritos, chabot de ayuda, carrito de compra, seccion de administrador, registro de usuarios, reseñas de componentes, envio de mail, metodo de pago con Stripe, login con terceros(Google)
            <br />
            Tecnologias: ReactJs, Bootstrap, CSS modules, Express, Sequelize, Autenticacion (JWT), Nodemailer, Stripe.    
          </p>
        </div>
        <div className="w-full flex flex-col items-center p-4 md:w-1/2 ">
          <h2 className="text-xl mb-4 font-medium md:text-3xl">E-Commerce (Audifonos y speakers) 🎧</h2>
          <a
            href="https://ecommerce-six-rho.vercel.app/"
            className="w-full ease-in-out duration-300 hover:brightness-110"
          >
            <Card
              name="Weather App"
              description={
                ""
              }
              image={eCommerce2}
            />
          </a>
          <p className="w-full my-3 text-md text-justify md:text-xl">
            Pagina de práctica de un ecommerce de venta de dispositivos de sonido.
            Contiene: Carrito de compras, visualizacion de productos, metodo de pago con stripe.
            <br />
            Tecnologias: NextJs, CSS, Back con Sanity   
          </p>
        </div>
      </div>
    </div>
  );
}


export default Projects;
